// AdminNews.tsx

import React, { useState } from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { TableNews } from '@/components/admin/News/TableNews';
import { Button } from '@/components/common/Button';
import { NewsItem } from '@/API/admin/news';
import { CreateNewsModal } from '@/components/admin/News/CreateNewsModal';

export const AdminNews: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState<NewsItem | undefined>(
    undefined
  );

  const handleCreateNew = () => {
    setSelectedNews(undefined);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedNews(undefined);
  };

  return (
    <AdminLayout>
      <div className="flex justify-between items-start h-16 mb-6">
        <h2 className="text-xl font-bold">ニュースを編集する</h2>
        <div>
          <Button onClick={handleCreateNew}>新規作成</Button>
        </div>
      </div>
      <div className="bg-white pt-6 shadow-lg">
        <TableNews />
      </div>
      <div>
        <CreateNewsModal isOpen={isModalOpen} onClose={closeModal} />
      </div>
    </AdminLayout>
  );
};
